export { AvatarIcon, hashStringToColor } from './AvatarIcon';
